import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { RestaurantDetails } from '../../restaurants/models/List.Restaurant';
import { RestaurantService } from '../../restaurants/services/Restaurant.service';
import { ListData, ListFilter, ReviewsList, TotalReviews, rateType, reviewRate } from '../models/List.GuestReviews';
import { ReviewService } from '../services/Reviews.service';
import { ReportReviewFormComponent } from './report-review-form/report-review-form.component';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-guests-reviews',
  templateUrl: './guests-reviews.component.html'
})
export class GuestsReviewsComponent implements OnInit {
  dataLoading = true;
  topDataLoading = true;
  showFilter = false;
  showSearch = false;
  pageIndex = 0;
  pageCount = 0;
  pageSize = 10;
  typeValue!: any;

  filterFormGroup: FormGroup = new FormGroup({});
  filterModel: ListFilter = new ListFilter();
  today = new Date();

  // Restaurant ID
  restaurantId?: any;
  allRestaurants: RestaurantDetails[] = [];
  restaurantData!: any;

  recordsData!: ListData | null;
  topRates!: ListData | null;
  selectedReviewId!: any;

  typesListAll = [
    { name: this.translate.instant('reviews.All'), id: reviewRate.All },
    { name: 5, id: reviewRate.Five },
    { name: 4, id: reviewRate.Four },
    { name: 3, id: reviewRate.Three },
    { name: 2, id: reviewRate.Two },
    { name: 1, id: reviewRate.one },
  ];

  rateType = rateType;
  starRating = 2.5;
  lineRating = 3.5

  subscriptions: Subscription[] = [];

  dataBinded = false;
  totalReviews!: TotalReviews | null;
  listData!: ReviewsList | null;

  constructor(
    private translate: TranslateService,
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private service: ReviewService,
    private route: ActivatedRoute,
    private router: Router,
    private restaurantService: RestaurantService,
    private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.filterModel.pageSize = this.pageSize;
    this.filterModel.rates = reviewRate.All
    this.buildFilterForm()

    this.subscriptions.push(
      this.service.refreshList.subscribe(data => {
        if (data) {
          if (this.recordsData && this.recordsData.listReviews.length > 1) {
            this.getAll(true, this.restaurantId);
          } else {
            this.getAll(null, this.restaurantId);
          }
        }
      })
    )
    this.service.openReviewDetailsID.subscribe(data => {
      this.selectedReviewId = null;
      if (data) {
        this.selectedReviewId = data;
      }
    });
    this.activatedRoute.queryParamMap.subscribe(params => {
      // Notification
      if (params.get('reviewsId') && params.get('restaurantId')) {
        this.selectedReviewId = Number(params.get('reviewsId'));
        this.restaurantId = Number(params.get('restaurantId'));
        this.getAll(null, this.restaurantId);
      }
    });
  }

  GetRestaurantShortDetails(restaurantId: any) {
    this.restaurantService.GetRestaurantShortDetails(restaurantId).subscribe((data: any) => {
      this.restaurantData = data
    })
  }

  ngOnDestroy() {
    this.service.refreshList.next(false);
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  buildFilterForm() {
    this.filterFormGroup = this.formBuilder.group({
      dateFrom: [''],
      dateTo: ['']
    });
  }

  getTopReviews(restId?: any) {
    this.topDataLoading = true;
    this.restaurantId = restId;
    this.service.getTotalServiceReviews(this.restaurantId).subscribe((data: any) => {
      this.topDataLoading = false;
      if (data) {
        this.topRates = data;
        console.log(this.topRates)
      }
    })
  }

  getAll(event: any, restId?: any) {
    this.dataLoading = true;
    this.restaurantId = restId;
    if (!event) {
      this.pageIndex = 0;
    }
    if (event && event.pageSize) {
      this.pageIndex = event.pageIndex;
      this.filterModel.pageSize = event.pageSize;
    }
    this.filterModel.pageNumber = this.pageIndex;
    this.filterModel.resturantID = this.restaurantId
    this.service.getAllReviews(this.filterModel).subscribe(
      (data: ListData) => {
        this.dataLoading = false;
        if (data) {
          this.listData = {
            pageIndex: data.pageIndex,
            pageSize: data.pageSize,
            totalCount: data.totalCount,
            listReviews: data.listReviews
          }
          this.pageCount = Math.ceil(this.listData.totalCount / this.filterModel.pageSize);
          // if (!this.dataBinded) {
          //   this.totalReviews = {
          //     totalRateReview: data.totalRateReview,
          //     totalReviewsCount: data.totalCount,
          //     servicesReviewsTotal: data.servicesReviewsTotal
          //   }
          // }
          // this.dataBinded = true;
        }
      },
      (error: any) => {
        this.recordsData = null;
        this.listData = null;
        // this.totalReviews = null;
        this.dataLoading = false;
      });
  }

  typeFilter(selected: any) {
    const selectedType = this.typesListAll.find(element => element.id === selected.value);
    if (selectedType) {
      this.typeValue = selectedType;
    }
    this.makeFilter();
  }

  makeFilter() {
    const controls = this.filterFormGroup.controls;
    this.filterModel.dateFrom = controls['dateFrom'].value;
    this.filterModel.dateTo = controls['dateTo'].value;
    // this.filterModel.rates = controls['companionsNumber'].value;

    this.getAll(null, this.restaurantId);
  }
  clearFilter() {
    this.filterModel = new ListFilter();
    this.filterModel.pageSize = this.pageSize
    this.getAll(null, this.restaurantId);
    this.filterModel.rates = reviewRate.All;
    this.filterFormGroup.reset();
  }


  makeSearch() {
    if (!this.showSearch) {
      this.showSearch = true; // Show input
    } else {
      if (this.filterModel.searchText) {
        this.getAll(null, this.restaurantId);
      }
    }
  }

  resetSearch() {
    this.filterModel.searchText = '';
    this.getAll(null, this.restaurantId);
  }

  openReportForm(reviewId: number) {
    const dialogRef = this.dialog.open(ReportReviewFormComponent, {
      width: '50rem',
      data: { reviewId }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.service.refreshList.next(true);
      }
    });
  }

  closeDetails() {
    this.selectedReviewId = null;
    this.router.navigate([location.pathname]);
  }

  GetScreenData() {
    this.recordsData = null;
    this.getAll(null, this.restaurantId);
    this.GetRestaurantShortDetails(this.restaurantId);
    this.getTopReviews(this.restaurantId)
  }
}
